import React, { useEffect, useState } from 'react';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import useComparable from '~/commons/hooks/useComparable';
import PageHttp from '~/commons/components/PageHttp.jsx';
import ListPagination from '~/commons/components/ListPagination.jsx';
import { env } from '~/commons/config';
import BtnLimit from '../../app/components/btns/BtnLimit.jsx';
import GridArticles from './GridArticles.jsx';
import ListArticles from './ListArticles.jsx';

const Articles = ({ filter }) => {
  const [res, req, fetched = { total: 0 }] = useHttpStatus();
  const [query, setQuery] = useState({
    skip: 0,
    sort: { title: 1 },
    limit: 20,
  });
  const [mode, setMode] = useState('grid');
  const attachment = env.subjects[filter.subjects]?.attachment;

  const fetch = (q) => {
    const nq = { ...query, ...q };

    setQuery(nq);
    req({
      url: 'api/quiz/articles',
      params: {
        ...nq,
        filter,
      },
    });
  };

  useEffect(() => {
    const q = { skip: 0 };

    fetch(q);
  }, [useComparable(filter)]);

  return (
    <div className="container">
      {fetched && (
        <h4 className="text-center text-primary">
          共有文章 {fetched.total} 篇
        </h4>
      )}
      {/* controls */}
      <div className="form-row align-items-center">
        <div className="col-12 col-md">
          <div className="form-row">
            <div className="col-auto my-3">
              <BtnLimit query={query} onQuery={fetch} />
            </div>
            <div className="col-auto my-3">
              <ListPagination
                size="sm"
                {...{
                  ...query,
                  total: fetched.total,
                  onChange: fetch,
                }}
              />
            </div>
          </div>
        </div>
        {attachment && (
          <div className="col-md-auto my-3 mx-md-3">
            <a
              href={attachment.url}
              className="btn btn-outline-secondary mt-md-3 mb-3 mb-md-4"
              download={attachment.originalname}
            >
              <FA icon={faDownload} fixedWidth />
              下載文章
            </a>
          </div>
        )}
        <div className="col-auto my-3">
          <div className="form-row">
            <div className="col-auto">
              <button
                className="btn btn-link p-0"
                onClick={() => setMode('grid')}
              >
                <img
                  src={`assets/img/grid_view_${mode === 'grid' ? '' : 'in'}active.svg`}
                  style={{ width: '35px' }}
                />
                <small className="d-block mt-1">
                  <small>預覽模式</small>
                </small>
              </button>
            </div>
            <div className="col-auto">
              <button
                className="btn btn-link p-0"
                onClick={() => setMode('list')}
              >
                <img
                  src={`assets/img/list_view_${mode === 'list' ? '' : 'in'}active.svg`}
                  style={{ width: '35px' }}
                />
                <small className="d-block mt-1">
                  <small>列表模式</small>
                </small>
              </button>
            </div>
          </div>
        </div>
      </div>

      <PageHttp res={res} className="position-relative">
        {() => (mode === 'grid'
          ? <GridArticles rows={fetched.rows} />
          : <ListArticles rows={fetched.rows} />
        )}
      </PageHttp>

      <div className="row justify-content-end">
        <div className="col-auto">
          <ListPagination
            size="sm"
            {...{
              ...query,
              total: fetched.total,
              onChange: fetch,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Articles;
